export default "__VITE_ASSET__2b1c9638__"